import classNames from 'classnames/bind';
import { get } from 'lodash';
import styles from './BreadcrumbSortItem.module.scss';

const classNameBuilder = classNames.bind(styles);

export const BreadcrumbSortItem = ({ item, sort }) => {
    const currentSortField = get(sort, '0.field');
    const currentOrderField = get(sort, '0.order');

    const isActive = !item.parentValue
        ? currentSortField === item.value
        : currentSortField === item.parentValue && currentOrderField === item.value;

    return (
        <div className={classNameBuilder('option', { active: isActive })}>
            <span className={styles['option-content']}>
                <span className={styles['label']}>{item.label}</span>
            </span>
        </div>
    );
};
